import { z } from 'zod';

// ── Skill bucket (server → client) ─────────────────────────────────────────

export const SkillBucketSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  name: z.string(),
  sortOrder: z.number().int(),
  skills: z.array(z.string()),  // assigned skills, returned in GET response
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

// ── Create request (client → server) ─────────────────────────────────────────

export const CreateSkillBucketSchema = z.object({
  name: z.string().min(1).max(100).trim(),
});

// ── Update request ───────────────────────────────────────────────────────────

export const UpdateSkillBucketSchema = z.object({
  name: z.string().min(1).max(100).trim().optional(),
});

// ── List response ────────────────────────────────────────────────────────────

export const SkillBucketListResponseSchema = z.object({
  buckets: z.array(SkillBucketSchema),
  unclassified: z.array(z.string()),  // skills not in any bucket
});

// ── Assign skill request ─────────────────────────────────────────────────────

export const AssignSkillSchema = z.object({
  skill: z.string().min(1).max(200).trim(),
});

// ── Batch reorder request ────────────────────────────────────────────────────

export const ReorderSkillBucketSchema = z.object({
  reorders: z.array(
    z.object({
      id: z.string().uuid(),
      sortOrder: z.number().int(),
    }),
  ),
});

// ── Derived types ────────────────────────────────────────────────────────────

export type SkillBucket = z.infer<typeof SkillBucketSchema>;
export type SkillBucketListResponse = z.infer<typeof SkillBucketListResponseSchema>;
export type CreateSkillBucket = z.infer<typeof CreateSkillBucketSchema>;
export type UpdateSkillBucket = z.infer<typeof UpdateSkillBucketSchema>;
export type AssignSkill = z.infer<typeof AssignSkillSchema>;
export type ReorderSkillBucket = z.infer<typeof ReorderSkillBucketSchema>;
export type ReorderSkillBucketItem = z.infer<
  typeof ReorderSkillBucketSchema
>['reorders'][number];
